var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-card-title',{staticClass:"blue--text darken-4"},[_vm._v("Messages")]),_vm._v(" "),_c('MessageList',{attrs:{"messages":_vm.messages}}),_vm._v(" "),_c('v-card-text',[_c('v-layout',[_c('v-flex',{attrs:{"xs10":"","offset-xs1":""}},[_c('MessageInput',{attrs:{"onSend":_vm.onSend}})],1)],1)],1)],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-08ccd34a","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Chat.vue
// module id = 340
// module chunks = 1